const RELEVANCE_ORDER = { central: 0, secundária: 1, terciária: 2 };
const UNKNOWN_RELEVANCE_PRIORITY = 3;

const normalizeRelevance = (val) =>
  typeof val === "string" ? val.trim().toLowerCase() : null;

const getRelevancePriority = (c) => {
  const val = normalizeRelevance(c.relevance?.value);
  return val in RELEVANCE_ORDER ? RELEVANCE_ORDER[val] : UNKNOWN_RELEVANCE_PRIORITY;
};

const getCharacterName = (c) => {
  const identification = c.identifications?.[0];
  if (!identification) return "";
  return `${identification.name ?? ""} ${identification.lastName ?? ""}`.trim();
};

const getTalentName = (c) => {
  const phase = (c.phases ?? []).find((item) => !!item?.talent);
  return phase?.talent?.trim() ?? "";
};

const compareStrings = (a, b) => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a.localeCompare(b, "pt-BR", { sensitivity: "base" });
};

export const sortCharacters = (a, b) => {
  const statusDiff = (a.isActive ? 0 : 1) - (b.isActive ? 0 : 1);
  if (statusDiff !== 0) return statusDiff;

  const relevanceDiff = getRelevancePriority(a) - getRelevancePriority(b);
  if (relevanceDiff !== 0) return relevanceDiff;

  const weightDiff = (b.weight ?? 0) - (a.weight ?? 0);
  if (weightDiff !== 0) return weightDiff;

  const nameDiff = compareStrings(getCharacterName(a), getCharacterName(b));
  if (nameDiff !== 0) return nameDiff;

  return compareStrings(getTalentName(a), getTalentName(b));
};
